import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const CheckStarSolidIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('CheckStarSolidIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
    data-track-tag={dataTrackTag}
  >
    <path
      fillRule="evenodd"
      d="M8.804.791a1.256 1.256 0 0 0-1.608 0L5.652 2.078H3.334c-.694 0-1.256.562-1.256 1.256v2.318L.791 7.196a1.256 1.256 0 0 0 0 1.608l1.287 1.544v2.318c0 .694.562 1.256 1.256 1.256h2.318l1.544 1.287a1.256 1.256 0 0 0 1.608 0l1.544-1.287h2.318c.694 0 1.256-.562 1.256-1.256v-2.318l1.287-1.544a1.256 1.256 0 0 0 0-1.608l-1.287-1.544V3.334c0-.694-.562-1.256-1.256-1.256h-2.318zm2.264 5.869a.718.718 0 0 0-1.111-.91L7.229 9.086l-.875-.875a.718.718 0 1 0-1.015 1.015l1.436 1.436a.72.72 0 0 0 1.063-.053z"
      clipRule="evenodd"
    />
  </svg>
);
CheckStarSolidIcon.id = 'CheckStarSolidIcon';
CheckStarSolidIcon.displayName = 'CheckStarSolidIcon';
export default CheckStarSolidIcon;
